module.exports = __webpack_public_path__ + "img/industri_smvf.28435582.jpg";